import { render, staticRenderFns } from "./EmailTemplateNew.vue?vue&type=template&id=0c4b2cdc"
import script from "./EmailTemplateNew.vue?vue&type=script&lang=ts"
export * from "./EmailTemplateNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports